module.exports = __webpack_public_path__ + "img/pic_coin_right.a1a891be.svg";